import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/sftp/explorer")({
    beforeLoad: () => {
        throw redirect({ to: "/developer/sftp/organisations", replace: true });
    },
});
